export default __webpack_public_path__ + "static/media/j_wdt_c_1.92cfea23.mp3";